import { Injectable } from '@angular/core';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppEnum } from './appenum';

@Injectable()
export class AppSettings {
    public addressPic1: any;
    public addressPic2_1: any;
    public addressPic2_2: any;
    public addressPic: any = [];
    public capturedInspectionMedia = false;
    public selectedLanguage = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale));
    public taskData: any;
    constructor(
        private encryptionService: EncryptionService, private _appenum: AppEnum
    ) { }
}

